import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { EstadoSituacionStepperComponent } from './components/estado-situacion/estado-situacion-stepper/estado-situacion-stepper.component';
import { NuevaSolicitudCreditoComponent } from './components/nueva-solicitud-credito/nueva-solicitud-credito.component';
import { PerfilUsuarioComponent } from './components/perfil-usuario/perfil-usuario.component';
import { OfertasCreditoComponent } from './components/ofertas-credito/ofertas-credito.component';
import { OfertaDetalleComponent } from './components/oferta-detalle/oferta-detalle.component';
import { ConversationsListComponent } from './components/mensajes/conversations-list/conversations-list.component';
import { ManejoErroresComponent } from './components/manejo-errores/manejo-errores.component';
import { RegistroExitosoComponent } from './components/registro-exitoso/registro-exitoso.component';
import { HomeComponent } from './components/home/home.component';
import { HistorialComponent } from './components/historial/historial.component';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'mi-perfil', component: PerfilUsuarioComponent, canActivate: [AuthGuard] },
  { path: 'estado-situacion', component: EstadoSituacionStepperComponent, canActivate: [AuthGuard]},
  { path: 'nueva-solicitud-credito', component: NuevaSolicitudCreditoComponent, canActivate: [AuthGuard]},
  { path: 'nueva-solicitud-credito/:guid', component: NuevaSolicitudCreditoComponent, canActivate: [AuthGuard]},
  { path: 'ofertas/:solicitudId', component: OfertasCreditoComponent },
  { path: 'solicitudes/:solicitudId/ofertas/:ofertaId', component: OfertaDetalleComponent },
  { path: 'conversaciones-listado', component: ConversationsListComponent , canActivate: [AuthGuard]},
  { path: 'registro-exitoso', component: RegistroExitosoComponent},
  { path: 'manejo-errores', component: ManejoErroresComponent },
  { path: 'historial', component: HistorialComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
